import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './loader.css';

export default class Loader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      proceed: false,
      progress: 0,
      hidden: true,
    };
    this.hideTimeout = null;
    this.proceedTimeout = null;
    this.finishedTimeout = null;

    this.barEl = null;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.loading < 0) {
      return;
    }
    if (nextProps.loading !== this.props.loading) {
      window.clearTimeout(this.hideTimeout);
      window.clearTimeout(this.proceedTimeout);
      window.clearTimeout(this.finishedTimeout);
    }
    if (nextProps.loading > 0) {
      this.setState({ hidden: false });
    }
    if (this.props.loading > 0 && nextProps.loading === 0) {
      this.setState(
        { progress: 500, proceed: false },
        this.startFinishedTimeout,
      );
    } else if (this.props.loading === 0 && nextProps.loading > 0) {
      this.setState(
        {
          progress: Math.floor(Math.random() * (60 - 40)) + 40,
          proceed: false,
        },
        this.startProceedTimeout,
      );
    } else if (nextProps.loading > this.props.loading) {
      const currentProgress =
        (this.barEl.scrollWidth / this.barEl.parentElement.scrollWidth) * 100;
      const delta = (currentProgress * 20) / 100;
      this.setState(
        { progress: currentProgress - delta, proceed: false },
        this.startProceedTimeout,
      );
    } else if (nextProps.loading < this.props.loading) {
      const currentProgress =
        (this.barEl.scrollWidth / this.barEl.parentElement.scrollWidth) * 100;
      const delta = ((100 - currentProgress) * 20) / 100;
      this.setState(
        { progress: currentProgress + delta, proceed: false },
        this.startProceedTimeout,
      );
    }
  }

  startProceedTimeout() {
    this.proceedTimeout = window.setTimeout(() => {
      this.setState({ progress: 100, proceed: true });
    }, 400); // 400ms as in CSS
  }

  startFinishedTimeout() {
    this.finishedTimeout = window.setTimeout(() => {
      this.setState({ hidden: true });
      setTimeout(() => {
        this.setState({ progress: 0 });
      }, 400); // After hide animation
    }, 1000); // Hide after 1 second
  }

  componentWillUnmount() {
    window.clearTimeout(this.hideTimeout);
    window.clearTimeout(this.finishedTimeout);
    window.clearTimeout(this.proceedTimeout);
  }

  render() {
    return (
      <div className="loader-wrapper">
        <div
          className={cx('loader', {
            'loader-inactive': this.state.hidden,
            'slow-loading': this.state.proceed,
          })}
        >
          <div
            className="bar"
            style={{ width: `${this.state.progress}%` }}
            ref={el => (this.barEl = el)}
          />
        </div>
      </div>
    );
  }
}

Loader.defaultProps = {
  loading: 0,
};

Loader.propTypes = {
  loading: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/ui/src/component/loader/loader.js